import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M22.749 22.818h-2.063c-.917 0-.917 1.364 0 1.364h2.063v2.045c0 .91 1.375.91 1.375 0v-2.045h2.063c.917 0 .917-1.364 0-1.364h-2.063v-2.045c0-.91-1.375-.91-1.375 0v2.045Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.436 16c-4.177 0-7.563 3.358-7.563 7.5 0 4.143 3.386 7.5 7.563 7.5C27.614 31 31 27.642 31 23.5c0-4.143-3.386-7.5-7.564-7.5Zm0 13.636c-3.417 0-6.188-2.746-6.188-6.136s2.77-6.136 6.188-6.136c3.419 0 6.189 2.746 6.189 6.136s-2.77 6.136-6.189 6.136Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.48 17.366c-1.303 1.592-2.103 3.753-2.103 6.134 0 2.38.8 4.54 2.102 6.132a58.3 58.3 0 0 1-.727.004c-4.666 0-8.593-.482-11.785-1.452-1.335-.406-2.158-1.708-1.929-3.051l.591-3.459c.368-2.15 2.184-3.784 4.414-3.972 2.677-.226 5.58-.338 8.709-.338.244 0 .487 0 .728.002Zm6.148-9.548c0 3.766-3.079 6.818-6.876 6.818-3.798 0-6.876-3.052-6.876-6.818C7.876 4.053 10.954 1 14.752 1c3.797 0 6.876 3.053 6.876 6.818Z",
    fill: "currentColor"
  }));
};

var SvgAddUser = styled(SvgComponent).withConfig({
  displayName: "AddUser__SvgAddUser",
  componentId: "sc-16d8i25-0"
})(["", " ", ""], size, color);
export default SvgAddUser;